import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../ProductsConfig';
import { config as deliveryChange } from './delivery-change-config/RO';

export const statements: DeepPartial<StatementsConfig> = {
    validate: {
        periodLength: true,
        maxDaysInPast: true,
    },
    creation: {
        differenceLimit: 92,
    },
    deliveryEditorVersion: 2,
    creditCardDeliverySelectable: true,
    modes: {
        electronic: 'ONLY_ELECTRONIC',
        postal: 'PAPER',
    },
    addAccessTokenToDownloadParams: true,
    addAccessTokenToDownloadBody: true,
    tableColumns: {
        DEFAULT: ['NAME', 'TIMESPAN', 'FORMAT', 'DOWNLOAD'],
        CREDIT: ['NAME', 'INVOICE_DATE', 'BALANCE', 'DOWNLOAD'],
    },
    isDescriptionInputVisible: true,
    newStatement: {
        maxDaysBetweenErrorKey: 'account.statements.newStatement.max3Months',
    },
    deliveryChange,
};
